/* eslint react/prop-types: 0 */
import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import loadTranslations from '../../locales'
import PageLoading from '../page-loading'

const LocaleWrapper = props => {
  const { children, dataLang } = props
  const [messages, setMessages] = useState(loadTranslations('fr'))
  //Display loading until the translation file is loaded. it prevents console errors
  const [isLoading, setLoading] = useState(true)

  const changeLocale = async () => {
    setMessages(await loadTranslations(dataLang.locale))
    setLoading(false)
  }

  useEffect(() => {
    changeLocale()
  }, [dataLang.locale])

  return isLoading ? (
    <PageLoading />
  ) : (
    <IntlProvider
      textComponent="span"
      locale={dataLang.locale}
      defaultLocale={dataLang.defaultLocale}
      messages={messages}
      data-test="component-local-wrapper-intlProvider"
      currency="EUR"
    >
      <ConfigProvider locale={dataLang.antLocale} data-test="local-wrapper-localeProvider">
        {children}
      </ConfigProvider>
    </IntlProvider>
  )
}

LocaleWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  dataLang: PropTypes.shape().isRequired
}

export default LocaleWrapper
